window.addEventListener("message", event => {
    if (event.data.src === "maaple") {
        switch (event.data.msg) {
            case "get-location":
                sendResponse(JSON.parse(JSON.stringify(window.location)));
                break;
            case "redirect":
                sendResponse("ack");
                window.location.href = event.data.data.dest;
                break;
        }
    }
    function sendResponse(result) {
        event.ports[0].postMessage({ result: result });
    }
});
